import React from 'react';
export function HeartDivider({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center justify-center gap-4 w-full max-w-xs mx-auto my-12 ${className}`} data-id="element-5">
      <div className="h-px bg-gold/40 flex-1" data-id="element-6"></div>
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-gold/60" data-id="element-7">
        <path d="M8 13.5L6.84 12.44C2.72 8.7 0 6.24 0 3.24C0 1.04 1.74 -0.7 3.94 -0.7C5.18 -0.7 6.36 -0.12 7.14 0.78L8 1.76L8.86 0.78C9.64 -0.12 10.82 -0.7 12.06 -0.7C14.26 -0.7 16 1.04 16 3.24C16 6.24 13.28 8.7 9.16 12.45L8 13.5Z" fill="currentColor" fillOpacity="0.2" stroke="currentColor" strokeWidth="1" data-id="element-8" />
      </svg>
      <div className="h-px bg-gold/40 flex-1" data-id="element-9"></div>
    </div>;
}
export function ThinArrow() {
  return <div className="flex items-center w-12 md:w-24 px-2" data-id="element-10">
      <div className="h-[1px] bg-olive/40 flex-1" data-id="element-11"></div>
      <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-olive/40 -ml-1" data-id="element-12">
        <path d="M1 1L5 5L1 9" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-13" />
      </svg>
    </div>;
}